<style lang="scss" scoped>
.slide-17 {
  background-image: url(../../../assets/module2/slide17/background.png);
  background-position: center;
  background-size: cover;
  position: relative;
  .frank {
    position: relative;
    z-index: 1;
  }

  .heading1 {
    position: relative;
    z-index: 0;
    color: #f8dc61;
    font-size: 170px;
    transform: rotate(-5deg);
    width: 100%;
    margin: auto;
    transform-origin: 100% 0;
    position: absolute;
    left: 0;
    top: 0;
    text-align: center;
  }
  .pages {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    padding-top: 300px;
  }
  .heading2 {
    width: 50%;
    margin-bottom: 30px;
  }
  .copy1,
  .copy2,
  .copy3 {
    width: 85%;
    font-size: 30px;
    margin-bottom: 30px;
  }

  .heading3 {
    margin-left: 220px;
    margin-top: 30px;
  }
  .heading4 {
    margin-left: 220px;
    color: #09509c;
  }
  .heading5 {
    margin-left: 270px;
  }
  .heading6 {
    margin-left: 240px;
  }
  .heading7 {
    margin-left: 270px;
  }
  .heading8 {
    margin-left: 320px;
  }

  a {
    &:visited {
      color: #fff;
    }
  }
  .close {
    position: absolute;
    width: 100px;
    right: 10px;
    bottom: 10px;
    z-index: 10;
    cursor: pointer;
  }
}
</style>

<template>
  <div class="slide-17">
    <transition name="scale" appear>
      <div class="delay-1" v-show="slideIndex == 16">
        <h1 class="heading1">{{ $t("module2.slide17.heading1") }}</h1>
      </div>
    </transition>
    <transition name="fadeUp" appear>
      <img
        v-show="slideIndex == 16"
        src="@/assets/module2/slide17/frank@2x.png"
        class="delay-2 frank"
      />
    </transition>
    <div class="pages">
      <div class="page page-left">
        <transition name="fadeLeft" appear>
          <div class="delay-1" v-show="slideIndex == 16">
            <h1 class="heading2">{{ $t("module2.slide17.heading2") }}</h1>
          </div>
        </transition>
        <transition name="fadeLeft" appear>
          <div class="delay-2" v-show="slideIndex == 16">
            <p class="copy1">{{ $t("module2.slide17.copy1") }}</p>
          </div>
        </transition>
        <transition name="fadeLeft" appear>
          <div class="delay-3" v-show="slideIndex == 16">
            <p class="copy2">{{ $t("module2.slide17.copy2") }}</p>
          </div>
        </transition>
        <transition name="fadeLeft" appear>
          <div class="delay-4" v-show="slideIndex == 16">
            <p class="copy3">
              <a href="http://www.fastheroes.com/" target="_blank"
                >www.fastheroes.com</a
              >
            </p>
          </div>
        </transition>
      </div>

      <div class="page page-right">
        <transition name="fadeRight" appear>
          <div class="delay-5" v-show="slideIndex == 16">
            <h1 class="heading3">{{ $t("module2.slide17.heading3") }}</h1>
          </div>
        </transition>

        <transition name="fadeRight" appear>
          <div class="delay-6" v-show="slideIndex == 16">
            <h1 class="heading4">{{ $t("module2.slide17.heading4") }}</h1>
          </div>
        </transition>

        <transition name="fadeRight" appear>
          <div class="delay-7" v-show="slideIndex == 16">
            <h1 class="heading5">{{ $t("module2.slide17.heading5") }}</h1>
          </div>
        </transition>

        <transition name="fadeRight" appear>
          <div class="delay-8" v-show="slideIndex == 16">
            <h1 class="heading6">{{ $t("module2.slide17.heading6") }}</h1>
          </div>
        </transition>

        <transition name="fadeRight" appear>
          <div class="delay-9" v-show="slideIndex == 16">
            <h1 class="heading7">{{ $t("module2.slide17.heading7") }}</h1>
          </div>
        </transition>

        <transition name="fadeRight" appear>
          <div class="delay-10" v-show="slideIndex == 16">
            <h1 class="heading8">{{ $t("module2.slide17.heading8") }}</h1>
          </div>
        </transition>
      </div>
    </div>
    <img
      @click.prevent="reload()"
      class="close"
      src="@/assets/module1/slide27/button_close.png"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      showVideo: false
    };
  },
  props: ["slideIndex"],
  methods: {
    reload() {
      window.location = "/e-books/";
    }
  }
};
</script>
